import React from 'react'
import _ from 'lodash'
import { ADDITIONAL_FORM_FIELD_PROPS, COMMON_FORM_FIELD_PROPS, FORM_FIELD_CONTROL_PROPS } from './FORM_FIELD_PROP_TYPES'

const Checkbox = ({
  id,
  label,
  onChange,
  value,
  disabled,
}) => {

  const outerLabelClass = [
    'Checkbox',
    (disabled && 'is-disabled')
  ].filter(Boolean).join(' ')

  return <label className={outerLabelClass}>
    <input
      id={id}
      data-testid={id}
      type='checkbox'
      value={id}
      onChange={() => onChange({ target: { value: !value } })}
      checked={value}
      disabled={disabled}
    />
    <div className='Checkbox-wrapper'>
      <span className='Checkbox-span'>
        <span className='Checkbox-select' />
      </span>
      {label && <span className='Checkbox-label'>{label}</span>}
    </div>
  </label>
}

Checkbox.propTypes = {
  ..._.omit(FORM_FIELD_CONTROL_PROPS, ['onBlur', 'error']),
  ..._.pick(COMMON_FORM_FIELD_PROPS, ['id', 'label']),
  ..._.pick(ADDITIONAL_FORM_FIELD_PROPS, 'disabled')
}

export default Checkbox